/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { isDocumentNumberField } from "@Helpers/constants";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiGitCompare } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdArrowDropDown } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import fileConversionStatusInProgress from "@Assets/icons/svg/FileConversionStatusInProgress.svg?react";
import fileConversionStatusUnsuccessfull from "@Assets/icons/svg/FileConversionStatusUnsuccessfull.svg?react";
import { convertDate } from "@Services/luxonHelper";
import DesignViewerLayoutManager from "@Features/design-viewer/components/DesignViewerLayoutManager";
import { setMinimizerData } from "@Reducers/minimizerFloatter";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import { getViewerUrl, extractRedirectUrl, extractRedirectUrlAsString } from "@Helpers";
import { setViewerState, setModalStatus, setShowOnlyModal } from "@Reducers/Viewer";
import { getFileImage } from "@Services/utils/iconMap";
import { BIM_ENGINE, CAD_ENGINE, PDF_ENGINE } from "@Services/constants";
import useModulesMapper from "@Components/StickySidebarViewer/ModulesMapper.jsx";
import _ from "lodash";
import { getTransmittalAttachedFiles } from "@Features/transmittals";
import { getChildrenFilesName } from "@Actions/Viewer";
import { setHelpSectionState } from "@Reducers/portalDashboard";
import IconComponent from "@CubeComponents/icons";
import Text from "@CubeComponents/html/Text/Text";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { RootState } from "@Reducers/index";
import type { FileVersionData, SourceFileVersionData } from "@Types/fileOperations";

function DesignViewerHeader({
  isPageOpenedThroughTransmittal,
  currentVersionNumber,
  fileName,
  fileVersionsDropDownItems,
  handleComparedFileModelChange,
  handleComparedFileVersionChange,
  handleFileVersionIdChange,
  HoopsViewer,
  currentfileVersionId,
  engineType,
  modalToOpen,
  enableDesignViewerLayoutManager,
  estimateId,
  scheduleId,
  constituentFilesProcessingStatus,
  resetDesignViewer,
  setTransmittalId,
}: any) {
  const { t } = useTranslation();
  const { projectData, helpSectionState } = useSelector((state: RootState) => state);
  const { parentId } = useSelector(
    (state: RootState): Partial<FileVersionData> => state.filesData[currentfileVersionId] || {},
  );
  const layout = useSelector((state: RootState) => state.layout);
  const showDocAndRevisionInViewer = !!layout?.FILE_MANAGER?.SHOW_DOC_AND_REVISION_IN_VIEWER;
  const customFieldValues = useSelector((state: RootState) => state.filesData[currentfileVersionId]?.customFields);
  const fileFormTemplate = useSelector((state: RootState) => state.filesData[currentfileVersionId]?.formTemplate);
  const revisionLabel = useSelector((state: RootState) => state.filesData[currentfileVersionId]?.revisionSeries?.label);
  const documentNumber = React.useMemo(() => {
    if (!showDocAndRevisionInViewer || !customFieldValues) return "";
    const sections = (fileFormTemplate ?? []) as { questionFields?: { _id?: string; questionValue?: string }[] }[];
    for (const section of sections) {
      const question = (section?.questionFields ?? []).find((field) => isDocumentNumberField(field?.questionValue));
      if (question?._id) return String(customFieldValues[question._id] ?? "");
    }
    return "";
  }, [showDocAndRevisionInViewer, customFieldValues, fileFormTemplate]);
  const HoopsModalStatus = useSelector((state: RootState) => state.HoopsModalStatus);
  const fileVersions = useSelector((state: RootState) => state.fileVersions);

  const navigate = useNavigate();
  const MAXIMIZE = "maximize";
  const MINIMIZE = "minimize";
  const DISMISS = "dismiss";
  const ICON_DEFAULT = "ICON_DEFAULT";
  const ICON_ARROW_MAXIMIZE = "ICON_ARROW_MAXIMIZE";
  const ICON_ARROW_MINIMIZE = "ICON_ARROW_MINIMIZE";

  const [openVersionDropdown, setOpenVersionDropdown] = useState(false);
  const [FileNameDropdown, setFileNameDropdown] = useState(false);
  const [inputHeading, setInputHeading] = useState("");
  const [showMinimizeIcon, setShowMinimizeIcon] = useState(false);
  const [showDismissIcon, setShowDismissIcon] = useState(false);
  const [childrenFiles, setChildrenFiles] = useState<any[]>([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const Url = new URLSearchParams(location.search);
  const spaceId = Url.get("spaceId");
  const [maximizeIconState, setMaximizeIconState] = useState(ICON_DEFAULT);
  const [modulesMapper] = useModulesMapper({
    estimateId: !!Url.get("estimateId"),
    fileVersionId: currentfileVersionId,
  }) as any;

  useEffect(() => {
    if (isPageOpenedThroughTransmittal) {
      setInputHeading(`TS-${currentVersionNumber}`);
    } else {
      setInputHeading(`V${currentVersionNumber}`);
    }
  }, [isPageOpenedThroughTransmittal, currentVersionNumber]);

  const handleVersionDropDownClick = () => {
    if (!(estimateId || scheduleId) || [PDF_ENGINE].includes(engineType)) {
      setOpenVersionDropdown(!openVersionDropdown);
    }
  };

  const getResroucetypeOfCurrentFileVersion = () => {
    if (!fileVersions || !currentfileVersionId) return "";
    for (const fileVersionObjs of Object.values(fileVersions)) {
      if (!Array.isArray(fileVersionObjs)) continue;
      for (const fv of fileVersionObjs) {
        const version = fv as SourceFileVersionData & { resourceType?: string };
        if (version?.id === currentfileVersionId) return version?.resourceType || "";
      }
    }
    return "";
  };

  const HtmlTooltip = styled(({ className, ...props }: any) => (
    <Tooltip
      arrow
      {...props}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -7],
              },
            },
          ],
        },
      }}
      classes={{ popper: className }}
    />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#192048",
      color: "#FFF",
      maxWidth: "28.125rem",
      maxHeight: "9.375rem",
      height: "auto",
      width: "auto",
      borderRadius: "0.25rem",
      border: "none",
      position: "relative",
      display: "flex",
      gap: "1rem",
      padding: "1rem 2rem",
      "& p": {
        color: "#FFF",
        fontFamily: '"Source Sans 3"',
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        flexGrow: 1,
        wordBreak: "break-word",
      },
      "& button": {
        color: "#FFF",
        fontFamily: '"Source Sans 3"',
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
        whiteSpace: "nowrap",
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        "inset-inline-start": 0,
        "inset-inline-end": 0,
        bottom: 0,
        borderRadius: "inherit",
        pointerEvents: "none",
      },
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "#192048",
      "&::before": {
        backgroundColor: "#192048",
      },
    },
  }));

  const renderProcessingStatusIcon = () => {
    if (!constituentFilesProcessingStatus || constituentFilesProcessingStatus.status === "COMPLETED") return null;

    const IconSrc =
      constituentFilesProcessingStatus.status === "ERROR"
        ? fileConversionStatusUnsuccessfull
        : fileConversionStatusInProgress;
    const handleButtonClick = () => {
      if (constituentFilesProcessingStatus.status === "PROCESSING") {
        globalThis.location.reload();
      }
      if (constituentFilesProcessingStatus.status === "ERROR") {
        dispatch(
          setModalStatus({
            ...HoopsModalStatus,
            ConstituentFiles: _.get(HoopsModalStatus, "ConstituentFiles.show")
              ? { show: false }
              : {
                  show: true,
                  currentStage: "constituentFiles",
                  defaultStage: "constituentFiles",
                  backStage: "constituentFiles",
                },
          }),
        );
      }
    };
    return (
      <HtmlTooltip
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <p>{constituentFilesProcessingStatus.message}</p>
            <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleButtonClick}>
              <b>{constituentFilesProcessingStatus.buttonContent}</b>
            </ButtonComponent>
          </div>
        }
      >
        <IconButton
          className="px-2 py-0"
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            },
          }}
        >
          <IconSrc />
        </IconButton>
      </HtmlTooltip>
    );
  };

  const handleFileVersionRedirectClick = (e: React.MouseEvent<HTMLElement>) => {
    const fileVersionId = e.currentTarget.attributes["data-fileversionid"].value;
    const spaceId1 = spaceId as any;
    const currentMode = new URLSearchParams(globalThis.location.search).get("mode");
    const viewerUrl = getViewerUrl({
      fileVersionId,
      spaceId: spaceId1,
      projectId: projectData._id,
      mode: currentMode === "scs" || currentMode === "skipProperties" ? currentMode : undefined,
      redirectTo: extractRedirectUrl(location),
    }) as any;
    resetDesignViewer();
    navigate(viewerUrl, { replace: true });
    setOpenVersionDropdown(false);
    handleFileVersionIdChange(fileVersionId);
  };

  const handleTransmittalFileVersionRedirectClick = (e: React.MouseEvent<HTMLElement>, url: any) => {
    const fileVersionId = e.currentTarget.attributes["data-fileversionid"].value;
    const transmittalIdMatch = url.match(/[?&]transmittalId=([^&]*)/);
    const transmittalId = transmittalIdMatch ? decodeURIComponent(transmittalIdMatch[1]) : null;
    handleFileVersionIdChange(fileVersionId);
    setTransmittalId(transmittalId);
    resetDesignViewer();
    navigate(url, { replace: true });
    setOpenVersionDropdown(false);
  };

  const handleFileVersionCompareClick = (val: any) => {
    setOpenVersionDropdown(false);
    if ([PDF_ENGINE].includes(engineType)) {
      dispatch(
        setViewerState({
          pdfCompare: {
            active: true,
            baseFileVersionId: currentfileVersionId,
            revisionFileVersionId: val.fileVersionId,
          },
        }),
      );
      return;
    }
    handleComparedFileModelChange(val.awsFileName.split(","));
    handleComparedFileVersionChange(val.fileVersionId);
    dispatch(setShowOnlyModal("ModelCompare"));
  };

  const navigateToRedirectOrBack = () => {
    const redirectUrl = extractRedirectUrlAsString(location);
    redirectUrl ? navigate(redirectUrl) : navigate(-1);
  };

  const cleanupViewer = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    resetDesignViewer();
  };

  const executeMinimizeActions = () => {
    navigateToRedirectOrBack();
    dispatch(
      setMinimizerData({
        path: location.pathname + location.search,
        text: fileName,
      }),
    );
  };

  const executeCloseActions = () => {
    if (globalThis.opener) {
      globalThis.close();
    } else {
      navigateToRedirectOrBack();
    }
  };

  const handleMinimizeViewer = () => {
    cleanupViewer();
    executeMinimizeActions();
  };

  const handleCloseViewer = () => {
    cleanupViewer();
    executeCloseActions();
  };

  const handleFullScreenViewer = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (
      document.documentElement.requestFullscreen &&
      typeof document.documentElement.requestFullscreen === "function"
    ) {
      document.documentElement.requestFullscreen();
    }
  };

  const handleClickFileListDropDown = () => {
    if (!(estimateId || scheduleId)) {
      setFileNameDropdown(!FileNameDropdown);
    }
  };

  const getFiles = async () => {
    if (isPageOpenedThroughTransmittal) {
      const transmittalId = Url.get("transmittalId")!;
      const allTransmittalFiles = await getTransmittalAttachedFiles({
        transmittalId,
        spaceId: spaceId!,
      });
      setChildrenFiles(allTransmittalFiles.data as any);
    } else {
      const shortcutParentId = Url.get("shortcutParentId");
      const finalParentId = shortcutParentId || parentId;
      if (finalParentId) {
        try {
          const allFiles = await getChildrenFilesName({ finalParentId, spaceId: spaceId! });
          setChildrenFiles(
            allFiles.filter(
              (file: any) =>
                ["RESOURCE_TYPE_MERGED_FILE", "RESOURCE_TYPE_SHORTCUT_FILE", "RESOURCE_TYPE_FILE"].includes(
                  file.resourceType,
                ) && file.permission?.read,
            ),
          );
        } catch (err) {
          Promise.reject(err);
          setChildrenFiles([]);
        }
      }
    }
  };

  useEffect(() => {
    if (parentId && spaceId) {
      getFiles();
    }
  }, [parentId, spaceId, location.search]);

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (
      !(
        target.closest("#filesListDropDown") ||
        target.closest("#versionsListDropDown") ||
        target.closest("#layoutDropDown")
      )
    ) {
      setFileNameDropdown(false);
      setOpenVersionDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleIconsMouseOver = (e: React.MouseEvent<HTMLElement>) => {
    const type = (e.currentTarget as any).attributes.id.value;

    if (type == MAXIMIZE) {
      if (document.fullscreenElement) {
        setMaximizeIconState(ICON_ARROW_MINIMIZE);
      } else {
        setMaximizeIconState(ICON_ARROW_MAXIMIZE);
      }
    } else if (type == MINIMIZE) {
      setShowMinimizeIcon(true);
    } else if (type == DISMISS) {
      setShowDismissIcon(true);
    }
  };

  useEffect(() => {
    if (PDF_ENGINE.includes(engineType)) {
      const modalStatus: any = {};
      dispatch(setViewerState({ sidebarData: ["Issues", "Properties"] }));
      if (modalToOpen.length > 0) {
        modalToOpen = modalToOpen.filter((data: any) => modulesMapper[data]?.isVisible);
        for (const dock of modalToOpen) {
          const initializeState = modulesMapper[dock]?.initialState || {};
          (modalStatus as any)[dock] = {
            show: true,
            ...initializeState,
          };

          if (dock === "Issues") {
            (modalStatus as any)[dock].currentStage = "view_issue";
          }
        }
      }
      dispatch(setModalStatus(modalStatus));
    }
  }, [engineType]);

  const handleIconsMouseOut = (e: React.MouseEvent<HTMLElement>) => {
    const type = (e.currentTarget as any).attributes.id.value;

    if (type == MAXIMIZE) {
      setMaximizeIconState(ICON_DEFAULT);
    } else if (type == MINIMIZE) {
      setShowMinimizeIcon(false);
    } else if (type == DISMISS) {
      setShowDismissIcon(false);
    }
  };

  const handleHelpSectionClick = () => {
    dispatch(setHelpSectionState({ display: !helpSectionState.display, module: "general" }));
  };

  const handleChangeTransmittalFile = (transmittalFileObj: any) => {
    const transmittalVersionId = Url.get("transmittalId") as any;
    const transmittalFileLink = getViewerUrl({
      fileVersionId: transmittalFileObj.fileVersionId,
      spaceId: transmittalFileObj.toSpace,
      transmittalVersionId,
      projectId: projectData.id,
      redirectTo: extractRedirectUrl(location),
    }) as any;
    resetDesignViewer();
    navigate(transmittalFileLink, { replace: true });
    setFileNameDropdown(false);
  };

  const handleChangeModel = (fileVersionId: any) => {
    const spaceId1 = spaceId as any;
    const viewerUrl = getViewerUrl({
      fileVersionId,
      spaceId: spaceId1,
      projectId: projectData._id,
      redirectTo: extractRedirectUrl(location),
    });
    resetDesignViewer();
    navigate(viewerUrl as any, { replace: true });
    setFileNameDropdown(false);
  };

  return (
    <div className="z-20" data-testid="designViewerHeader">
      <div
        className="flex items-center rounded-lg bg-[linear-gradient(90.03deg,rgba(255,255,255,0.8)_0%,rgba(255,255,255,0.4)_100%)] py-2 ps-6 text-[#333]"
        data-testid="fileInfoSection"
      >
        <div className="w-14">
          <GiHamburgerMenu size="1.2rem" color="#555555" />
        </div>
        <div className="grid grid-cols-[auto_auto_auto] items-center" data-testid="leftInfoSection">
          <Box
            data-testid="fileListDropdown"
            onClick={handleClickFileListDropDown}
            className={`flex pe-2  border-e border-black ${
              estimateId || scheduleId ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
            }`}
            id="filesListDropDown"
          >
            <ToolTipComponent position="right" content={fileName}>
              <div data-testid="fileName" className="max-w-72  truncate text-base font-semibold">
                {showDocAndRevisionInViewer ? documentNumber || fileName : fileName}
              </div>
            </ToolTipComponent>
            {renderProcessingStatusIcon()}
            <MdArrowDropDown size="1.5rem" />
          </Box>

          {showDocAndRevisionInViewer && (
            <Box className="flex px-2 border-e border-black" data-testid="viewerRevision">
              <ToolTipComponent position="bottom" content={t("Revision")}>
                <div className="truncate text-base font-semibold">{revisionLabel || "-"}</div>
              </ToolTipComponent>
            </Box>
          )}

          <Box
            data-testid="fileVersionDropdown"
            onClick={handleVersionDropDownClick}
            className={`flex pe-2 ps-3 border-e border-black ${
              (estimateId || scheduleId) && ![PDF_ENGINE].includes(engineType)
                ? "opacity-50 cursor-not-allowed"
                : "cursor-pointer"
            }`}
            id="versionsListDropDown"
          >
            <div data-testid="inputHeading" className="text-base font-semibold">
              {inputHeading}
            </div>
            <MdArrowDropDown size="1.5rem" />
            {openVersionDropdown && (
              <div
                data-testid="fileVersionPopOver"
                className="absolute overflow-auto -ms-3 border border-white bg-white rounded-lg shadow-md"
                style={{ top: "4.25rem", maxHeight: "34.375rem" }}
              >
                <div style={{ height: "100%", overflow: "auto" }} data-testid="fileVersionDropdownItems">
                  {fileVersionsDropDownItems?.map((val: any) => {
                    const formattedTime = convertDate(Number(val.createdDate), "dateForText");
                    const formattedTimeForToolTip = convertDate(Number(val.createdDate), "dateForTooltip");
                    let isDisabled = false;
                    if (currentVersionNumber == val.versionNumber) {
                      isDisabled = true;
                    }
                    return (
                      <div
                        key={`dropDownVersion_${val.text}`}
                        className="grid grid-cols-[auto_auto] gap-x-4 cursor-pointer px-4 py-2.5"
                      >
                        <Box
                          data-fileversionid={val.fileVersionId}
                          onClick={(e) =>
                            isPageOpenedThroughTransmittal
                              ? handleTransmittalFileVersionRedirectClick(e, val.url)
                              : handleFileVersionRedirectClick(e)
                          }
                          className={`grid w-32 grid-cols-[auto_auto] text-sm font-normal ${isDisabled || estimateId || scheduleId ? "pointer-events-none opacity-50" : ""}`}
                        >
                          <span>{val.text}</span>
                          <span className="ps-4 text-[#979797]">
                            <ToolTipComponent showTipPointer position="bottom" content={formattedTimeForToolTip}>
                              {formattedTime}
                            </ToolTipComponent>
                          </span>
                        </Box>
                        {(([BIM_ENGINE, CAD_ENGINE].includes(engineType) && isDisabled === false) ||
                          [PDF_ENGINE].includes(engineType)) &&
                        getResroucetypeOfCurrentFileVersion() != "RESOURCE_TYPE_MERGED_FILE" ? (
                          <ToolTipComponent position="left" content={t("Compare")}>
                            <Box
                              className="flex cursor-pointer items-center text-accentBlue"
                              onClick={() => handleFileVersionCompareClick(val)}
                            >
                              <BiGitCompare />
                            </Box>
                          </ToolTipComponent>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Box>
          {[BIM_ENGINE, CAD_ENGINE].includes(engineType) && enableDesignViewerLayoutManager && layout.DESIGNVIEWER && (
            <DesignViewerLayoutManager
              HoopsViewer={HoopsViewer}
              modalToOpen={modalToOpen}
              fileVersionId={currentfileVersionId}
            />
          )}
        </div>
        <div className="ms-auto flex items-center gap-4 pe-4" data-testid="rightInfoSection">
          <IconComponent
            onClick={handleHelpSectionClick}
            position={"left"}
            toolTipContent={t("Help Section")}
            showGradient={(helpSectionState.display && helpSectionState.module == "general") ?? undefined}
            name="help"
            width="1.5rem"
            height="1.5rem"
          />
          <Box
            onMouseEnter={handleIconsMouseOver}
            onMouseLeave={handleIconsMouseOut}
            className="h-4 w-4 cursor-pointer bg-alice_blue hover:bg-bright_yellow rounded-full flex items-center justify-center transition-colors duration-100"
            id={MINIMIZE}
          >
            <IconComponent
              key={MINIMIZE}
              name={"minimizeIcon"}
              width="0.5rem"
              height="0.5rem"
              toolTipContent={t("Minimize")}
              position="top"
              onClick={handleMinimizeViewer}
              data-testid="minimise"
              parentContainerClass="h-2.5 w-2.5"
              isVisible={showMinimizeIcon}
            />
          </Box>
          <Box
            onMouseEnter={handleIconsMouseOver}
            onMouseLeave={handleIconsMouseOut}
            className="h-4 w-4 cursor-pointer bg-alice_blue hover:bg-green-600 rounded-full flex items-center justify-center transition-colors duration-100"
            id={MAXIMIZE}
          >
            <IconComponent
              key={MAXIMIZE}
              name={maximizeIconState == ICON_ARROW_MINIMIZE ? "exitFullScreen" : "enterFullScreen"}
              toolTipContent={maximizeIconState == ICON_ARROW_MINIMIZE ? t("Exit Full Screen") : t("Maximise")}
              position="top"
              onClick={handleFullScreenViewer}
              data-testid="maximise"
              parentContainerClass="h-3 w-3"
              isVisible={maximizeIconState !== ICON_DEFAULT}
              width="1.5rem"
              height="1.5rem"
            />
          </Box>
          <Box
            onMouseEnter={handleIconsMouseOver}
            onMouseLeave={handleIconsMouseOut}
            className="h-4 w-4 cursor-pointer bg-alice_blue hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-100"
            id={DISMISS}
          >
            <IconComponent
              key={DISMISS}
              name={"Cancel"}
              width="0.75rem"
              height="1rem"
              toolTipContent={t("Dismiss")}
              position="top"
              onClick={handleCloseViewer}
              data-testid="dismiss"
              parentContainerClass="h-4 w-3"
              isVisible={showDismissIcon}
            />
          </Box>
        </div>
      </div>
      {FileNameDropdown && (
        <div
          className="absolute overflow-auto border border-white bg-white rounded-lg shadow-md"
          style={{ top: "4.25rem", maxHeight: "75%", insetInlineStart: "6.5rem" }}
          data-testid="filesListData"
        >
          <div className="h-full overflow-auto w-72" data-testid="filesListDataContent">
            {childrenFiles.length && childrenFiles.length - 1 ? (
              childrenFiles.map(
                (val: any) =>
                  val.fileVersionId !== currentfileVersionId && (
                    <ToolTipComponent key={val.id} position="right" content={val.name}>
                      <Box
                        onClick={() =>
                          isPageOpenedThroughTransmittal
                            ? handleChangeTransmittalFile(val)
                            : handleChangeModel(val.fileVersion)
                        }
                        className="flex max-w-72 whitespace-nowrap items-center p-3 gap-2 cursor-pointer hover:bg-primary_blue"
                      >
                        <div>
                          <img src={getFileImage(val) as any} className="max-w-none" alt="file-icon" />
                        </div>
                        <div key={val.id} className="truncate " data-testid="filesListName">
                          {val.name}
                        </div>
                      </Box>
                    </ToolTipComponent>
                  ),
              )
            ) : (
              <div
                className="grid h-[3vh] w-[25vw] items-center ps-1 italic text-[#979797]"
                data-testid="noFilesToShow"
              >
                <Text>{t("No files to Show")}</Text>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default DesignViewerHeader;
